import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const HistoricalCombineResultServices = {
  getPlayersStatsComparison,
  getHistoricalGCDisplayFlag,
  getGroupPercentileDisplayFlag,
  getDEXABodyFatDisplayFlag,
  getIndividualStatsComparison,
};

async function getPlayersStatsComparison(obj) {
  const response = await APIHelper.post(
    `${APIURLConstants.GET_PLAYERS_COMPARISION_STATS_DATA}`,
    obj,
    authHeader()
  );
  return response;
}

async function getHistoricalGCDisplayFlag() {
  const response = await APIHelper.get(
    APIURLConstants.GET_HISTORICAL_GC_DISPLAY_FLAG,
    authHeader()
  );
  return response;
}

async function getGroupPercentileDisplayFlag() {
  const response = await APIHelper.get(
    APIURLConstants.GET_GROUP_PERCENTILE_DISPLAY_FLAG,
    authHeader()
  );
  return response;
}

async function getDEXABodyFatDisplayFlag() {
  const response = await APIHelper.get(
    APIURLConstants.GET_DEXA_BODY_FAT_DISPLAY_FLAG,
    authHeader()
  );
  return response;
}

async function getIndividualStatsComparison(obj) {
  const response = await APIHelper.post(
    `${APIURLConstants.GET_INDIVIDUAL_COMPARISION_STATS_DATA}`,
    obj,
    authHeader()
  );
  return response;
}
